var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { inject, observer } from 'mobx-react';
import { Button, InputLabel, Select, Grid, PaginationItem, TextField, MenuItem, FormControl, Pagination, TableHead, Chip, Menu, Box } from '@mui/material';
import { DateTime } from 'luxon';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import InputAdornment from '@mui/material/InputAdornment';
import Rating from '@mui/material/Rating';
import CircularProgress from '@mui/material/CircularProgress';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { PickersDay } from '@mui/x-date-pickers';
import Divider from '@mui/material/Divider';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import GradeIcon from '@mui/icons-material/Grade';
import TimerIcon from '@mui/icons-material/Timer';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import VideocamIcon from '@mui/icons-material/Videocam';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DateRangeIcon from '@mui/icons-material/DateRange';
import ArticleIcon from '@mui/icons-material/Article';
import ErrorIcon from '@mui/icons-material/Error';
import LanguageIcon from '@mui/icons-material/Language';
import PendingIcon from '@mui/icons-material/Pending';
import InfoIcon from '@mui/icons-material/Info';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import MenuIcon from '@mui/icons-material/Menu';
import CallIcon from '@mui/icons-material/Call';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import BugReportIcon from '@mui/icons-material/BugReport';
import EditIcon from '@mui/icons-material/Edit';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import AndroidLogo from '../assets/android.png';
import iOsLogo from '../assets/ios.png';
import { buildAddressString } from '../address-book/models';
import { NO_ID, hasId } from '../common/ids';
var ClaimList = /** @class */ (function (_super) {
    __extends(ClaimList, _super);
    function ClaimList(props) {
        var _a, _b;
        var _this = _super.call(this, props) || this;
        Object.defineProperty(_this, "header", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        var searchModeFromStorage = (_b = (_a = _this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.searchMode) !== null && _b !== void 0 ? _b : 0;
        _this.state = {
            menuAnchor: null,
            searchMode: searchModeFromStorage
        };
        return _this;
    }
    Object.defineProperty(ClaimList.prototype, "componentDidMount", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.props.addressBookStore) === null || _a === void 0 ? void 0 : _a.getAddresses())];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ClaimList.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b, _c, _d, _e;
            var claims = (_b = (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.claimsItems) !== null && _b !== void 0 ? _b : [];
            var rows = [];
            var previousDate = '';
            for (var i = 0; i < claims.length; i++) {
                var row = claims[i];
                var currentDate = ((_d = (_c = row.modifiedAt) !== null && _c !== void 0 ? _c : row.createdAt) !== null && _d !== void 0 ? _d : '').substr(0, 10);
                var renderDivider = false;
                if (previousDate) {
                    if (currentDate !== previousDate)
                        renderDivider = true;
                }
                else
                    renderDivider = true;
                previousDate = currentDate;
                rows.push(this.renderClaimRow(row, renderDivider));
            }
            return (_jsxs("div", __assign({ className: "claims-root" }, { children: [this.renderFilters(), _jsxs("div", __assign({ className: "claims-container" }, { children: [_jsx("div", __assign({ className: "claims-table-header", ref: function (e) { return _this.header = e; } }, { children: _jsx(Table, { children: this.renderHeader() }, void 0) }), void 0), ((_e = this.props.claimsStore) === null || _e === void 0 ? void 0 : _e.isBusy) ?
                                _jsx("div", __assign({ className: "claims-table-progress" }, { children: _jsx(CircularProgress, {}, void 0) }), void 0) :
                                _jsx("div", __assign({ className: "claims-table-container", onScroll: function (e) { return _this.onClaimsListScroll(e); } }, { children: _jsx(Table, __assign({ className: "claims-table-body" }, { children: _jsx(TableBody, { children: rows }, void 0) }), void 0) }), void 0)] }), void 0), this.renderFooter()] }), void 0));
        }
    });
    Object.defineProperty(ClaimList.prototype, "renderHeader", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
            var organizations = (_b = (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.organizations) !== null && _b !== void 0 ? _b : [];
            var renderOrganizationColumn = organizations.length > 0;
            return (_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, __assign({ style: this.buildCellStyle(30) }, { children: _jsx("div", __assign({ className: "flex-row align-center justify-center" }, { children: _jsx(IconButton, __assign({ className: "claims-list-collapse-all", onClick: function (e) { return _this.onCollapseAllClick(e); } }, { children: _jsx(ArrowRightIcon, { fontSize: "large" }, void 0) }), void 0) }), void 0) }), void 0), renderOrganizationColumn ?
                            (_jsx(TableCell, __assign({ style: this.buildCellStyle(120) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(CorporateFareIcon, {}, void 0), _jsx("span", { children: (_c = this.props.languageStore) === null || _c === void 0 ? void 0 : _c.getLabel('Claims.Organization') }, void 0)] }), void 0) }), void 0)) : null, _jsx(TableCell, __assign({ style: this.buildCellStyle(150) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(SupportAgentIcon, {}, void 0), _jsx("span", { children: (_d = this.props.languageStore) === null || _d === void 0 ? void 0 : _d.getLabel('Claims.Expert') }, void 0)] }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(120) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(AssignmentIcon, {}, void 0), _jsx("span", { children: (_e = this.props.languageStore) === null || _e === void 0 ? void 0 : _e.getLabel('Claims.ExternalID') }, void 0)] }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(120) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(NoteAddIcon, {}, void 0), _jsx("span", { children: (_f = this.props.languageStore) === null || _f === void 0 ? void 0 : _f.getLabel('Claims.Created') }, void 0)] }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(120) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(EditIcon, {}, void 0), _jsx("span", { children: (_g = this.props.languageStore) === null || _g === void 0 ? void 0 : _g.getLabel('Claims.LastChange') }, void 0)] }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(120) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(TimerIcon, {}, void 0), _jsx("span", { children: (_h = this.props.languageStore) === null || _h === void 0 ? void 0 : _h.getLabel('Claims.CallDuration') }, void 0)] }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(100) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(FilePresentIcon, {}, void 0), _jsx("span", { children: (_j = this.props.languageStore) === null || _j === void 0 ? void 0 : _j.getLabel('Claims.Photos') }, void 0)] }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(150) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(PhoneAndroidIcon, {}, void 0), _jsx("span", { children: (_k = this.props.languageStore) === null || _k === void 0 ? void 0 : _k.getLabel('Claims.Client') }, void 0)] }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(350) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(ArticleIcon, {}, void 0), _jsx("span", { children: (_l = this.props.languageStore) === null || _l === void 0 ? void 0 : _l.getLabel('Claims.ClaimInfo') }, void 0)] }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(150) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(GradeIcon, {}, void 0), _jsx("span", { children: (_m = this.props.languageStore) === null || _m === void 0 ? void 0 : _m.getLabel('Claims.Rating') }, void 0)] }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(112) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(MenuIcon, {}, void 0), _jsx("span", { children: (_o = this.props.languageStore) === null || _o === void 0 ? void 0 : _o.getLabel('Claims.Actions') }, void 0)] }), void 0) }), void 0)] }, void 0) }, void 0));
        }
    });
    Object.defineProperty(ClaimList.prototype, "renderClaimRow", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (row, renderDivider) {
            var _this = this;
            var _a, _b, _c, _d, _e;
            var buttonStyle = { 'padding': 0, 'margin': 0 };
            var expandIcon = row.calls.length === 0 ?
                null :
                _jsx(IconButton, __assign({ style: buttonStyle }, { children: row.isExpanded ? _jsx(ArrowDropDownIcon, { style: buttonStyle, fontSize: "large" }, void 0) : _jsx(ArrowRightIcon, { style: buttonStyle, fontSize: "large" }, void 0) }), void 0);
            var averageRating = this.getAverageRating(row.calls);
            var averageRatingElement = averageRating === 0
                ? null
                : _jsx(Rating, { name: "read-only", value: averageRating, precision: 0.1, readOnly: true }, void 0);
            var externalId = '';
            var customFieldValues = [];
            if (row.customFields) {
                var customFields = JSON.parse(row.customFields);
                for (var _i = 0, _f = Object.keys(customFields); _i < _f.length; _i++) {
                    var fieldName = _f[_i];
                    var fieldValue = customFields[fieldName];
                    if (fieldName === 'Field.ExternalID')
                        externalId = fieldValue;
                    else if (fieldValue)
                        customFieldValues.push(fieldValue);
                }
            }
            var description = (_a = row.description) !== null && _a !== void 0 ? _a : '';
            if (description) {
                var maxLength = 50;
                customFieldValues.push(description.length > maxLength ? description.slice(0, maxLength - 3) + '...' : description);
            }
            if (hasId(row.addressId)) {
                var address = (_c = (_b = this.props.addressBookStore) === null || _b === void 0 ? void 0 : _b.addresses) === null || _c === void 0 ? void 0 : _c.find(function (a) { return a.id === row.addressId; });
                if (address) {
                    customFieldValues.push(buildAddressString(address));
                }
            }
            var organizations = (_e = (_d = this.props.claimsStore) === null || _d === void 0 ? void 0 : _d.organizations) !== null && _e !== void 0 ? _e : [];
            var renderOrganizationColumn = organizations.length > 0;
            var divider = renderDivider ? (_jsx(TableRow, { children: _jsx(TableCell, __assign({ colSpan: renderOrganizationColumn ? 12 : 11 }, { children: _jsx("div", __assign({ className: "flex-row align-center justify-center" }, { children: _jsx("b", { children: _jsx(Chip, { color: "primary", label: this.buildDateString(row.modifiedAt, true), sx: { cursor: 'pointer' }, onClick: function (e) { return _this.onDateClick(e, row.modifiedAt); } }, void 0) }, void 0) }), void 0) }), void 0) }, void 0)) : null;
            var mobileUserName = row.mobileUserName;
            if (mobileUserName && mobileUserName.indexOf('@') === -1 && !isNaN(parseInt(mobileUserName))) {
                var matches = mobileUserName.match(new RegExp('.{1,4}$|.{1,3}', 'g'));
                if (matches)
                    mobileUserName = '+' + matches.join("-").trim();
            }
            return (_jsxs(React.Fragment, { children: [divider, _jsxs(TableRow, __assign({ className: row.calls.length > 0 ? 'claims-expandable-row' : '', onClick: function () { return _this.onToggleRowExpandModeClick(row); } }, { children: [_jsx(TableCell, __assign({ style: this.buildCellStyle(30), title: 'ID: ' + row.id }, { children: _jsx("div", __assign({ className: "flex-row align-center justify-center" }, { children: expandIcon }), void 0) }), void 0), renderOrganizationColumn ?
                                (_jsx(TableCell, __assign({ style: this.buildCellStyle(120), title: row.organizationName }, { children: _jsx("div", __assign({ className: "flex-row align-center" }, { children: _jsx("span", { children: _jsx("b", { children: row.organizationName }, void 0) }, void 0) }), void 0) }), void 0)) : null, _jsx(TableCell, __assign({ style: this.buildCellStyle(150) }, { children: _jsx("div", __assign({ className: "flex-row align-center" }, { children: _jsx("span", { children: this.buildUserDisplayName(row.agentFirstName, row.agentLastName, row.agentUserName) }, void 0) }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(120) }, { children: _jsx("div", __assign({ className: "flex-row align-center" }, { children: _jsx("span", { children: _jsx("b", { children: externalId }, void 0) }, void 0) }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(120) }, { children: _jsx("div", __assign({ className: "flex-row align-center" }, { children: _jsxs("span", { children: [this.buildDateString(row.createdAt, false), " ", this.buildTimeString(row.createdAt)] }, void 0) }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(120) }, { children: _jsx("div", __assign({ className: "flex-row align-center" }, { children: _jsxs("span", { children: [this.buildDateString(row.modifiedAt, false), " ", this.buildTimeString(row.modifiedAt)] }, void 0) }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(120) }, { children: _jsx("div", __assign({ className: "flex-row align-center" }, { children: _jsx("span", { children: this.buildDurationString(row.duration) }, void 0) }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(100) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [row.photoCount > 0
                                            ? _jsxs("div", __assign({ className: "flex-row align-center mr" }, { children: [_jsx(PhotoLibraryIcon, { className: "mr" }, void 0), " ", row.photoCount.toString()] }), void 0)
                                            : _jsx("div", {}, void 0), row.videoCount > 0
                                            ? _jsxs("div", __assign({ className: "flex-row align-center mr" }, { children: [_jsx(VideocamIcon, { className: "mr" }, void 0), " ", row.videoCount.toString()] }), void 0)
                                            : _jsx("div", {}, void 0), row.audioCount > 0
                                            ? _jsxs("div", __assign({ className: "flex-row align-center mr" }, { children: [_jsx(HeadphonesIcon, { className: "mr" }, void 0), " ", row.audioCount.toString()] }), void 0)
                                            : _jsx("div", {}, void 0)] }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(150), title: row.mobileUserName }, { children: _jsx("div", __assign({ className: "flex-row align-center" }, { children: this.renderTextCell(mobileUserName) }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(350) }, { children: _jsx("div", __assign({ className: "claims-fields" }, { children: customFieldValues.map(function (v, i) { return (_jsx(Chip, { label: v, color: "primary", size: "small", onClick: function (e) { return _this.onCustomFieldClick(e, v); }, variant: "outlined", style: { marginRight: '5px' } }, i)); }) }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(150) }, { children: _jsx("div", __assign({ className: "flex-row align-center" }, { children: averageRatingElement }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(100) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(IconButton, __assign({ color: "primary", size: "small", onClick: function (e) { return _this.onStartCallClick(e, row.id); } }, { children: _jsx(CallIcon, {}, void 0) }), void 0), _jsx(IconButton, __assign({ color: "primary", size: "small", onClick: function (e) { return _this.onOpenClaimClick(e, row.id); } }, { children: _jsx(OpenInFullIcon, {}, void 0) }), void 0), _jsx(IconButton, __assign({ color: "primary", size: "small", onClick: function (e) { return _this.onDownloadPhotosClick(e, row.id); } }, { children: _jsx(SaveAltIcon, {}, void 0) }), void 0)] }), void 0) }), void 0)] }), void 0), this.renderCalls(row.calls, row.isExpanded)] }, row.id));
        }
    });
    Object.defineProperty(ClaimList.prototype, "renderTextCell", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (text) {
            return (_jsx("span", { children: text }, void 0));
        }
    });
    Object.defineProperty(ClaimList.prototype, "onTextCellMouseEnter", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
        }
    });
    Object.defineProperty(ClaimList.prototype, "onTextCellMouseLeave", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
        }
    });
    Object.defineProperty(ClaimList.prototype, "onDateClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, dateStr) {
            var _a, _b, _c;
            e.stopPropagation();
            var from = DateTime.fromISO(dateStr).startOf('day');
            var to = DateTime.fromISO(dateStr).endOf('day');
            (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.updateFromDate(from.toJSDate());
            (_b = this.props.claimsStore) === null || _b === void 0 ? void 0 : _b.updateToDate(to.toJSDate());
            (_c = this.props.claimsStore) === null || _c === void 0 ? void 0 : _c.onUpdate(true);
        }
    });
    Object.defineProperty(ClaimList.prototype, "onCustomFieldClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, value) {
            var _a, _b;
            e.stopPropagation();
            (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.updateSearchText(value);
            (_b = this.props.claimsStore) === null || _b === void 0 ? void 0 : _b.onUpdate(true);
        }
    });
    Object.defineProperty(ClaimList.prototype, "buildDateString", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (dateStr, relative) {
            var _a, _b, _c;
            if (!dateStr)
                return '';
            var date = DateTime.fromISO(dateStr, { zone: 'UTC' }).startOf('day');
            var today = DateTime.local().startOf('day');
            var yesterday = today.minus({ days: 1 });
            if (relative && date >= today)
                return (_a = this.props.languageStore) === null || _a === void 0 ? void 0 : _a.getLabel('Claims.Today');
            if (relative && date >= yesterday)
                return (_b = this.props.languageStore) === null || _b === void 0 ? void 0 : _b.getLabel('Claims.Yesterday');
            var adapter = new AdapterDateFns();
            adapter.locale = (_c = this.props.languageStore) === null || _c === void 0 ? void 0 : _c.getMuiLocale();
            return adapter.formatByString(date.toJSDate(), 'P');
        }
    });
    Object.defineProperty(ClaimList.prototype, "buildTimeString", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (timeStr) {
            if (!timeStr)
                return '';
            return DateTime.fromISO(timeStr).toFormat('HH:mm');
        }
    });
    Object.defineProperty(ClaimList.prototype, "renderCalls", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (calls, isExpanded) {
            var _this = this;
            var _a, _b;
            var organizations = (_b = (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.organizations) !== null && _b !== void 0 ? _b : [];
            var renderOrganizationColumn = organizations.length > 0;
            return calls.map(function (call) { return _this.renderCall(call, renderOrganizationColumn, isExpanded); });
        }
    });
    Object.defineProperty(ClaimList.prototype, "renderCall", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (call, renderOrganizationColumn, isExpanded) {
            var _this = this;
            var _a, _b;
            var style = isExpanded ? {} : { display: 'none' };
            var organizations = (_b = (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.organizations) !== null && _b !== void 0 ? _b : null;
            var openCallLogsButton = organizations && organizations.length > 0
                ? _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(IconButton, __assign({ color: "primary", size: "small", onClick: function (e) { return _this.onOpenCallLogsClick(e, call); } }, { children: _jsx(BugReportIcon, {}, void 0) }), void 0), _jsx("span", { children: call.comment }, void 0)] }), void 0)
                : null;
            var callInfoText = this.buildCallInfoText(call);
            return (_jsxs(TableRow, __assign({ className: "row-expanded", style: style }, { children: [_jsx(TableCell, __assign({ style: this.buildCellStyle(30), title: 'ID: ' + call.id }, { children: _jsx("div", __assign({ className: "flex-row align-center justify-center" }, { children: this.renderCallStatusIcon(call) }), void 0) }), void 0), renderOrganizationColumn ? (_jsx(TableCell, __assign({ title: callInfoText }, { children: callInfoText }), void 0)) : null, _jsx(TableCell, __assign({ title: renderOrganizationColumn ? '' : callInfoText }, { children: renderOrganizationColumn ? '' : callInfoText }), void 0), _jsx(TableCell, {}, void 0), _jsx(TableCell, { children: call.createdOn ? this.buildDateString(call.createdOn, false) + ' ' + this.buildTimeString(call.createdOn) : '' }, void 0), _jsx(TableCell, {}, void 0), _jsx(TableCell, { children: this.buildDurationString(call.duration) }, void 0), _jsx(TableCell, { children: _jsxs("div", { children: [call.photoCount > 0
                                    ? _jsxs("div", __assign({ className: "flex-row align-center mr" }, { children: [_jsx(PhotoLibraryIcon, { className: "mr" }, void 0), " ", call.photoCount.toString()] }), void 0)
                                    : _jsx("div", {}, void 0), call.videoCount > 0
                                    ? _jsxs("div", __assign({ className: "flex-row align-center mr" }, { children: [_jsx(VideocamIcon, { className: "mr" }, void 0), " ", call.videoCount.toString()] }), void 0)
                                    : _jsx("div", {}, void 0), call.audioCount > 0
                                    ? _jsxs("div", __assign({ className: "flex-row align-center mr" }, { children: [_jsx(HeadphonesIcon, { className: "mr" }, void 0), " ", call.audioCount.toString()] }), void 0)
                                    : _jsx("div", {}, void 0)] }, void 0) }, void 0), _jsx(TableCell, { children: this.renderLinkSourceInfo(call) }, void 0), _jsx(TableCell, { children: this.renderCallerDeviceInfo(call) }, void 0), _jsx(TableCell, { children: call.rating > 0
                            ? _jsx(Rating, { name: "read-only", value: call.rating, readOnly: true }, void 0)
                            : null }, void 0), _jsx(TableCell, { children: openCallLogsButton }, void 0)] }), call.id));
        }
    });
    Object.defineProperty(ClaimList.prototype, "renderLinkSourceInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (call) {
            // TODO: review last recipient logic
            var icon;
            var label;
            if (call.lastRecipient) {
                var lastRecipient = call.lastRecipient.trim();
                if (lastRecipient.indexOf('@') !== -1) {
                    icon = _jsx(AlternateEmailIcon, {}, void 0);
                    label = 'Email';
                }
                else {
                    icon = _jsx(PhoneAndroidIcon, {}, void 0);
                    label = 'SMS';
                }
            }
            else {
                icon = _jsx(LanguageIcon, {}, void 0);
                label = 'datcar.online';
            }
            var osInfo;
            if (call.isAndroidAppCall) {
                osInfo = _jsx("img", { src: AndroidLogo, alt: "Android", title: "Android" }, void 0);
            }
            else if (call.isiOSAppCall) {
                osInfo = _jsx("img", { src: iOsLogo, alt: "iOS", title: "iOS" }, void 0);
            }
            return _jsxs("div", __assign({ className: "flex-row align-items-center" }, { children: [_jsx(Chip, { variant: "outlined", label: label, color: "info", size: "small", icon: icon, sx: { marginRight: '10px ' } }, void 0), osInfo] }), void 0);
        }
    });
    Object.defineProperty(ClaimList.prototype, "renderCallStatusIcon", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (call) {
            if (!call.finishedOn)
                return _jsx(PendingIcon, { color: "success" }, void 0);
            if (call.isCallerConnected || call.photoCount > 0)
                return _jsx(CheckCircleIcon, { color: "success" }, void 0);
            return _jsx(ErrorIcon, { color: "error" }, void 0);
        }
    });
    Object.defineProperty(ClaimList.prototype, "buildCallInfoText", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (call) {
            if (!call.finishedOn)
                return '';
            if (call.isCallerConnected || call.photoCount > 0)
                return '';
            return call.lastError;
        }
    });
    Object.defineProperty(ClaimList.prototype, "buildUserDisplayName", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (firstName, lastName, userName) {
            var displayName = '';
            if (firstName)
                displayName = firstName;
            if (lastName) {
                if (displayName)
                    displayName += ' ';
                displayName += lastName;
            }
            if (displayName)
                return displayName;
            return userName;
        }
    });
    Object.defineProperty(ClaimList.prototype, "renderCallerDeviceInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (call) {
            return [
                this.cleanupDeviceInfo(call.callerDeviceName, [0, 2]),
                this.cleanupDeviceInfo(call.callerDeviceOS, [1, 2]),
                this.cleanupDeviceInfo(call.callerDeviceBrowser, [0, 1])
            ].filter(function (v) { return v; }).map(function (v, i) {
                return (_jsx(Chip, { variant: "outlined", label: v, color: "info", size: "small", style: { marginRight: '5px' }, icon: _jsx(InfoIcon, {}, void 0) }, i));
            });
        }
    });
    Object.defineProperty(ClaimList.prototype, "cleanupDeviceInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (info, itemIndexes) {
            if (!info)
                return '';
            var split = info.split(', ');
            var result = '';
            for (var i = 0; i < itemIndexes.length; i++) {
                var itemIndex = itemIndexes[i];
                if (itemIndex < split.length) {
                    if (result)
                        result += ' ';
                    result += split[itemIndex];
                }
            }
            return result;
        }
    });
    Object.defineProperty(ClaimList.prototype, "renderFilters", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            /*if (this.props.claimsStore?.isFilterPaneVisible === false)
            {
                return (
                    <Grid container justifyContent="flex-end" sx={{ marginBottom: '5px' }}>
                        <Grid item>
                            <Button variant="outlined" size="large" onClick={(e) => this.onToggleFilterClick()}>
                                <FilterAltIcon fontSize="large" />
                            </Button>
                        </Grid>
                    </Grid>
                );
            }*/
            var _this = this;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
            var fromDate = (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.fromDate;
            var toDate = (_b = this.props.claimsStore) === null || _b === void 0 ? void 0 : _b.toDate;
            var countryFilter = this.renderCountryFilter((_c = this.props.claimsStore) === null || _c === void 0 ? void 0 : _c.countries, (_d = this.props.claimsStore) === null || _d === void 0 ? void 0 : _d.countryId);
            var organizationsFilter = this.renderOrganizationFilter((_e = this.props.claimsStore) === null || _e === void 0 ? void 0 : _e.organizations, (_f = this.props.claimsStore) === null || _f === void 0 ? void 0 : _f.organizationId, (_g = this.props.claimsStore) === null || _g === void 0 ? void 0 : _g.countryId);
            var caseTypeFilter = this.renderCaseTypeCodeFilter((_h = this.props.claimsStore) === null || _h === void 0 ? void 0 : _h.caseTypeCodes, (_j = this.props.claimsStore) === null || _j === void 0 ? void 0 : _j.caseTypeCodeId);
            var addressFilter = this.renderAddressFilter((_k = this.props.addressBookStore) === null || _k === void 0 ? void 0 : _k.addresses, (_l = this.props.claimsStore) === null || _l === void 0 ? void 0 : _l.addressId, (_m = this.props.claimsStore) === null || _m === void 0 ? void 0 : _m.caseTypeCodeId);
            var textSearchFilter = this.renderTextSearchFilter();
            var filters = [countryFilter, organizationsFilter, caseTypeFilter, addressFilter].filter(function (f) { return f !== null; });
            return (_jsxs(Grid, __assign({ container: true, direction: "row", sx: { flex: '0 0 auto', marginBottom: '5px' } }, { children: [_jsxs(Grid, __assign({ className: "claims-filter", container: true, item: true, xl: 11, lg: 10, md: 10, sm: 10, xs: 12, direction: "row", alignItems: "left" }, { children: [_jsx(Grid, __assign({ item: true, xl: 1, lg: 2, md: 3, sm: 3, xs: 3, container: true, direction: "row" }, { children: _jsxs(FormControl, __assign({ fullWidth: true }, { children: [_jsx(InputLabel, __assign({ shrink: true }, { children: (_o = this.props.languageStore) === null || _o === void 0 ? void 0 : _o.getLabel('Claims.Criteria') }), void 0), _jsxs(Select, __assign({ label: "Criteria", value: this.state.searchMode, onChange: function (e) { return _this.onChangeSearchMode(e); } }, { children: [_jsx(MenuItem, __assign({ value: "0" }, { children: (_p = this.props.languageStore) === null || _p === void 0 ? void 0 : _p.getLabel('Claims.CreatedDate') }), void 0), _jsx(MenuItem, __assign({ value: "1" }, { children: (_q = this.props.languageStore) === null || _q === void 0 ? void 0 : _q.getLabel('Claims.ModifiedDate') }), void 0)] }), void 0)] }), void 0) }), void 0), _jsxs(Grid, __assign({ item: true, xl: 3, lg: 4, md: 9, sm: 9, xs: 9, container: true, direction: "row", alignItems: "left" }, { children: [_jsx(LocalizationProvider, __assign({ dateAdapter: AdapterDateFns, adapterLocale: (_r = this.props.languageStore) === null || _r === void 0 ? void 0 : _r.getMuiLocale() }, { children: _jsx(DatePicker, { label: (_s = this.props.languageStore) === null || _s === void 0 ? void 0 : _s.getLabel('Claims.FromDate'), value: fromDate, disableFuture: true, onChange: function (e) { return _this.onFromDateChange(e); }, renderDay: function (day, _value, DayComponentProps) { return _this.renderDay(day, DayComponentProps, 'from'); }, renderInput: function (params) { return _jsx(TextField, __assign({}, params, { sx: { flex: 1 } }), void 0); } }, void 0) }), void 0), _jsx(IconButton, __assign({ onClick: function (e) { return _this.onDateButtonClick(e); }, className: "self-align-center" }, { children: _jsx(DateRangeIcon, { fontSize: 'large' }, void 0) }), void 0), _jsxs(Menu, __assign({ anchorEl: this.state.menuAnchor, open: Boolean(this.state.menuAnchor), onClose: function (e) { return _this.onMenuClose(''); } }, { children: [_jsx(MenuItem, __assign({ onClick: function (e) { return _this.onMenuClose('today'); } }, { children: (_t = this.props.languageStore) === null || _t === void 0 ? void 0 : _t.getLabel('Claims.Today') }), void 0), _jsx(MenuItem, __assign({ onClick: function (e) { return _this.onMenuClose('yesterday'); } }, { children: (_u = this.props.languageStore) === null || _u === void 0 ? void 0 : _u.getLabel('Claims.Yesterday') }), void 0), _jsx(MenuItem, __assign({ onClick: function (e) { return _this.onMenuClose('this-week'); } }, { children: (_v = this.props.languageStore) === null || _v === void 0 ? void 0 : _v.getLabel('Claims.ThisWeek') }), void 0), _jsx(MenuItem, __assign({ onClick: function (e) { return _this.onMenuClose('this-month'); } }, { children: (_w = this.props.languageStore) === null || _w === void 0 ? void 0 : _w.getLabel('Claims.ThisMonth') }), void 0), _jsx(Divider, {}, void 0), _jsx(MenuItem, __assign({ onClick: function (e) { return _this.onMenuClose('previous-week'); } }, { children: (_x = this.props.languageStore) === null || _x === void 0 ? void 0 : _x.getLabel('Claims.PreviousWeek') }), void 0), _jsx(MenuItem, __assign({ onClick: function (e) { return _this.onMenuClose('previous-month'); } }, { children: (_y = this.props.languageStore) === null || _y === void 0 ? void 0 : _y.getLabel('Claims.PreviousMonth') }), void 0)] }), void 0), _jsx(LocalizationProvider, __assign({ dateAdapter: AdapterDateFns, adapterLocale: (_z = this.props.languageStore) === null || _z === void 0 ? void 0 : _z.getMuiLocale() }, { children: _jsx(DatePicker, { label: (_0 = this.props.languageStore) === null || _0 === void 0 ? void 0 : _0.getLabel('Claims.ToDate'), value: toDate, disableFuture: true, onChange: function (e) { return _this.onToDateChange(e); }, renderDay: function (day, _value, DayComponentProps) { return _this.renderDay(day, DayComponentProps, 'to'); }, renderInput: function (params) { return _jsx(TextField, __assign({}, params, { sx: { flex: 1 } }), void 0); } }, void 0) }), void 0)] }), void 0), filters.map(function (f, i) { return _jsx(Grid, __assign({ item: true, xl: 1, lg: 2, md: 3, sm: 3, xs: 3, container: true, direction: "row" }, { children: f }), i); }), _jsx(Grid, __assign({ item: true, xl: 2, lg: 4, md: 6, sm: 12, xs: 12, container: true, direction: "row" }, { children: textSearchFilter }), void 0)] }), void 0), _jsx(Grid, __assign({ item: true, xl: 1, lg: 2, md: 2, sm: 2, xs: 12, container: true, direction: "row", alignItems: "flex-start", sx: { paddingTop: '3px' } }, { children: _jsx(Grid, __assign({ item: true, xs: 12, container: true }, { children: _jsxs(Button, __assign({ color: "primary", variant: "contained", size: "large", onClick: function (e) { return _this.onUpdateClick(); }, sx: { flex: '1', minWidth: '0' } }, { children: [_jsx(SearchIcon, { fontSize: "large" }, void 0), _jsx(Box, __assign({ sx: { marginLeft: '5px' } }, { children: (_1 = this.props.languageStore) === null || _1 === void 0 ? void 0 : _1.getLabel('Claims.Search') }), void 0)] }), void 0) }), void 0) }), void 0)] }), void 0));
        }
    });
    Object.defineProperty(ClaimList.prototype, "onDateButtonClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            this.setState(__assign(__assign({}, this.state), { menuAnchor: event.currentTarget }));
        }
    });
    Object.defineProperty(ClaimList.prototype, "onMenuClose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (period) {
            var _a, _b;
            this.setState(__assign(__assign({}, this.state), { menuAnchor: null }));
            var from;
            var to;
            switch (period) {
                case 'today':
                    to = DateTime.local().endOf('day');
                    from = to.startOf('day');
                    break;
                case 'yesterday':
                    to = DateTime.local().endOf('day').minus({ days: 1 });
                    from = to.startOf('day');
                    break;
                case 'this-week':
                    to = DateTime.local().endOf('day');
                    from = to.startOf('week');
                    break;
                case 'this-month':
                    to = DateTime.local().endOf('day');
                    from = to.startOf('month');
                    break;
                case 'previous-week':
                    to = DateTime.local().minus({ weeks: 1 }).endOf('week');
                    from = to.startOf('week');
                    break;
                case 'previous-month':
                    to = DateTime.local().minus({ months: 1 }).endOf('month');
                    from = to.startOf('month');
                    break;
                default:
                    break;
            }
            if (from && to) {
                (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.updateFromDate(from.toJSDate());
                (_b = this.props.claimsStore) === null || _b === void 0 ? void 0 : _b.updateToDate(to.toJSDate());
            }
        }
    });
    Object.defineProperty(ClaimList.prototype, "renderDay", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (day, DayComponentProps, element) {
            var _a, _b;
            var isDisabled = false;
            if (day) {
                var date = DateTime.fromJSDate(day);
                if (element === 'from' && ((_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.toDate)) {
                    var to = DateTime.fromJSDate(this.props.claimsStore.toDate);
                    date = date.startOf('day');
                    var today = DateTime.local().endOf('day');
                    if (date > today || date > to)
                        isDisabled = true;
                }
                else if (element === 'to' && ((_b = this.props.claimsStore) === null || _b === void 0 ? void 0 : _b.fromDate)) {
                    var from = DateTime.fromJSDate(this.props.claimsStore.fromDate);
                    date = date.endOf('day');
                    var today = DateTime.local().endOf('day');
                    if (date > today || date < from)
                        isDisabled = true;
                }
            }
            return (_jsx(PickersDay, __assign({}, DayComponentProps, { disabled: isDisabled }), void 0));
        }
    });
    Object.defineProperty(ClaimList.prototype, "renderTextSearchFilter", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b;
            var clearButton = (_jsx(InputAdornment, __assign({ position: "end" }, { children: _jsx(IconButton, __assign({ onClick: function (e) { return _this.onClearSearchTextClick(); }, edge: "end", sx: { display: ((_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.searchText) ? 'block' : 'none' } }, { children: _jsx(ClearIcon, {}, void 0) }), void 0) }), void 0));
            return (_jsx(FormControl, __assign({ variant: "outlined", fullWidth: true }, { children: _jsx(TextField, { variant: "outlined", InputLabelProps: { shrink: true }, onChange: function (e) { return _this.onSearchTextChanged(e); }, onKeyDown: function (e) { return _this.onSearchTextKeyDown(e); }, value: (_b = this.props.claimsStore) === null || _b === void 0 ? void 0 : _b.searchText, fullWidth: true, autoComplete: "off", label: "Text", sx: { flex: 1 }, InputProps: {
                        endAdornment: clearButton
                    } }, void 0) }), void 0));
        }
    });
    Object.defineProperty(ClaimList.prototype, "onSearchTextKeyDown", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b;
            if (e.key === 'Enter')
                (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.onUpdate(true);
            else if (e.key === 'Escape')
                (_b = this.props.claimsStore) === null || _b === void 0 ? void 0 : _b.updateSearchText('');
        }
    });
    Object.defineProperty(ClaimList.prototype, "onClearSearchTextClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a, _b;
            (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.updateSearchText('');
            (_b = this.props.claimsStore) === null || _b === void 0 ? void 0 : _b.onUpdate(true);
        }
    });
    Object.defineProperty(ClaimList.prototype, "renderCountryFilter", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (countries, selectedCountryId) {
            var _this = this;
            var _a, _b, _c;
            if (!countries || countries.length <= 1)
                return null;
            var options = (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.countries.map(function (t, index) {
                return _jsx(MenuItem, __assign({ value: t.key }, { children: t.value }), index);
            });
            return (_jsxs(FormControl, __assign({ variant: "outlined", fullWidth: true }, { children: [_jsx(InputLabel, { children: (_b = this.props.languageStore) === null || _b === void 0 ? void 0 : _b.getLabel('Claims.Country') }, void 0), _jsx(Select, __assign({ value: selectedCountryId, label: (_c = this.props.languageStore) === null || _c === void 0 ? void 0 : _c.getLabel('Claims.Country'), onChange: function (e) { return _this.onCountrySelectionChange(e); } }, { children: options }), void 0)] }), void 0));
        }
    });
    Object.defineProperty(ClaimList.prototype, "renderOrganizationFilter", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (organizations, selectedOrganizationId, selectedCountryId) {
            var _this = this;
            var _a, _b;
            if (!organizations || organizations.length <= 1)
                return null;
            var options = organizations.filter(function (o) {
                return selectedCountryId === NO_ID ||
                    o.key === NO_ID ||
                    !o.filterKey ||
                    o.filterKey === selectedCountryId;
            })
                .map(function (t, index) {
                return _jsx(MenuItem, __assign({ value: t.key }, { children: t.value }), index);
            });
            return (_jsxs(FormControl, __assign({ variant: "outlined", fullWidth: true }, { children: [_jsx(InputLabel, { children: (_a = this.props.languageStore) === null || _a === void 0 ? void 0 : _a.getLabel('Claims.Organization') }, void 0), _jsx(Select, __assign({ value: selectedOrganizationId, label: (_b = this.props.languageStore) === null || _b === void 0 ? void 0 : _b.getLabel('Claims.Organization'), onChange: function (e) { return _this.onOrganizationSelectionChange(e); } }, { children: options }), void 0)] }), void 0));
        }
    });
    Object.defineProperty(ClaimList.prototype, "renderCaseTypeCodeFilter", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseTypes, selectedCaseTypeCodeId) {
            var _this = this;
            var _a, _b;
            if (!caseTypes || caseTypes.length <= 1)
                return null;
            var options = caseTypes.map(function (t, index) {
                return _jsx(MenuItem, __assign({ value: t.key }, { children: t.value }), index);
            });
            return (_jsxs(FormControl, __assign({ variant: "outlined", fullWidth: true }, { children: [_jsx(InputLabel, { children: (_a = this.props.languageStore) === null || _a === void 0 ? void 0 : _a.getLabel('Claims.CaseType') }, void 0), _jsx(Select, __assign({ value: selectedCaseTypeCodeId, label: (_b = this.props.languageStore) === null || _b === void 0 ? void 0 : _b.getLabel('Claims.CaseType'), onChange: function (e) { return _this.onCaseTypeCodeSelectionChange(e); } }, { children: options }), void 0)] }), void 0));
        }
    });
    Object.defineProperty(ClaimList.prototype, "renderAddressFilter", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (addresses, addressId, caseTypeCodeId) {
            var _this = this;
            var _a, _b, _c;
            if (!addresses)
                return null;
            if (hasId(caseTypeCodeId)) {
                addresses = addresses.filter(function (a) { return a.caseTypeCodeIds && a.caseTypeCodeIds.indexOf(caseTypeCodeId) !== -1; });
            }
            var options = addresses.map(function (a, index) {
                return _jsx(MenuItem, __assign({ value: a.id }, { children: buildAddressString(a) }), index);
            });
            options.unshift(_jsx(MenuItem, __assign({ value: NO_ID }, { children: (_a = this.props.languageStore) === null || _a === void 0 ? void 0 : _a.getLabel('Claims.FilterAll') }), NO_ID));
            return (_jsxs(FormControl, __assign({ variant: "outlined", fullWidth: true }, { children: [_jsx(InputLabel, { children: (_b = this.props.languageStore) === null || _b === void 0 ? void 0 : _b.getLabel('AddressBook.Address') }, void 0), _jsx(Select, __assign({ value: addressId, label: (_c = this.props.languageStore) === null || _c === void 0 ? void 0 : _c.getLabel('AddressBook.Address'), onChange: function (e) { return _this.onAddressSelectionChange(e); } }, { children: options }), void 0)] }), void 0));
        }
    });
    Object.defineProperty(ClaimList.prototype, "renderFooter", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            var totalClaims = (_b = (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.totalClaims) !== null && _b !== void 0 ? _b : 0;
            var pageSize = (_d = (_c = this.props.claimsStore) === null || _c === void 0 ? void 0 : _c.pageSize) !== null && _d !== void 0 ? _d : 25;
            var pagesCount = Math.ceil(totalClaims / pageSize);
            return (_jsxs(Grid, __assign({ container: true, direction: "row", alignItems: "center", justifyContent: "space-between" }, { children: [_jsxs(FormControl, __assign({ variant: "outlined", style: { width: '100px' } }, { children: [_jsx(InputLabel, __assign({ id: "idClaimsPageSizeLabel" }, { children: (_e = this.props.languageStore) === null || _e === void 0 ? void 0 : _e.getLabel('Claims.PageSize') }), void 0), _jsxs(Select, __assign({ labelId: "idClaimsPageSizeLabel", label: (_f = this.props.languageStore) === null || _f === void 0 ? void 0 : _f.getLabel('Claims.PageSize'), variant: "outlined", value: pageSize, onChange: function (e) { return _this.onPageSizeChange(e); } }, { children: [_jsx(MenuItem, __assign({ value: "10" }, { children: "10" }), 0), _jsx(MenuItem, __assign({ value: "25" }, { children: "25" }), 1), _jsx(MenuItem, __assign({ value: "50" }, { children: "50" }), 2), _jsx(MenuItem, __assign({ value: "100" }, { children: "100" }), 3)] }), void 0)] }), void 0), _jsx(Box, __assign({ sx: { display: { xs: 'none', sm: 'block' } } }, { children: _jsxs("i", { children: [totalClaims, " ", (_g = this.props.languageStore) === null || _g === void 0 ? void 0 : _g.getLabel('Claims.Count')] }, void 0) }), void 0), _jsx(Pagination, { variant: "outlined", shape: "rounded", count: pagesCount, page: ((_j = (_h = this.props.claimsStore) === null || _h === void 0 ? void 0 : _h.pageIndex) !== null && _j !== void 0 ? _j : 0) + 1, renderItem: function (item) { var _a, _b; return _jsx(PaginationItem, __assign({}, item, { disabled: (item === null || item === void 0 ? void 0 : item.disabled) || ((_a = item === null || item === void 0 ? void 0 : item.page) !== null && _a !== void 0 ? _a : 0) - 1 === ((_b = _this.props.claimsStore) === null || _b === void 0 ? void 0 : _b.pageIndex) }), void 0); }, onChange: function (e, value) { return _this.onPageChange(e, value); } }, void 0)] }), void 0));
        }
    });
    Object.defineProperty(ClaimList.prototype, "onPageChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, value) {
            var _a;
            (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.updatePageIndex(value - 1);
        }
    });
    Object.defineProperty(ClaimList.prototype, "onChangeSearchMode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a;
            var selectionNum = e.target.value;
            this.setState(__assign(__assign({}, this.state), { searchMode: selectionNum }));
            (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.updateSearchMode(selectionNum);
        }
    });
    Object.defineProperty(ClaimList.prototype, "onPageSizeChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a;
            (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.updatePageSize(e.target.value);
        }
    });
    Object.defineProperty(ClaimList.prototype, "onStartCallClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, id) {
            var _a;
            e.stopPropagation();
            (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.onStartCall(id);
        }
    });
    Object.defineProperty(ClaimList.prototype, "onOpenClaimClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, id) {
            var _a;
            e.stopPropagation();
            (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.onOpenClaim(id);
        }
    });
    Object.defineProperty(ClaimList.prototype, "onDownloadPhotosClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, id) {
            var _a;
            e.stopPropagation();
            (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.onDownloadPhotos(id);
        }
    });
    Object.defineProperty(ClaimList.prototype, "onOpenCallLogsClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, call) {
            var _a;
            e.stopPropagation();
            (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.onOpenCallLogs(call.id, call.ticketId);
        }
    });
    Object.defineProperty(ClaimList.prototype, "onCollapseAllClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a;
            (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.setAllClaimsExpanded(false);
        }
    });
    Object.defineProperty(ClaimList.prototype, "onToggleRowExpandModeClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (row) {
            var _a;
            (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.setClaimExpanded(row.id, !row.isExpanded);
        }
    });
    Object.defineProperty(ClaimList.prototype, "onUpdateClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.onUpdate(true);
        }
    });
    Object.defineProperty(ClaimList.prototype, "onToggleFilterClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a, _b;
            (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.setIsFilterPaneVisible(!((_b = this.props.claimsStore) === null || _b === void 0 ? void 0 : _b.isFilterPaneVisible));
        }
    });
    Object.defineProperty(ClaimList.prototype, "onSearchTextChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a;
            (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.updateSearchText(e.target.value);
        }
    });
    Object.defineProperty(ClaimList.prototype, "onCountrySelectionChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a;
            (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.updateSelectedCountry(e.target.value);
        }
    });
    Object.defineProperty(ClaimList.prototype, "onOrganizationSelectionChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a;
            (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.updateSelectedOrganization(e.target.value);
        }
    });
    Object.defineProperty(ClaimList.prototype, "onCaseTypeCodeSelectionChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a;
            (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.updateSelectedCaseTypeCode(e.target.value);
        }
    });
    Object.defineProperty(ClaimList.prototype, "onAddressSelectionChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a;
            (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.updateSelectedAddress(e.target.value);
        }
    });
    Object.defineProperty(ClaimList.prototype, "onFromDateChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b, _c, _d;
            var fromDate = e;
            var toDate = (_c = (_b = (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.toDate) === null || _b === void 0 ? void 0 : _b.getTime()) !== null && _c !== void 0 ? _c : 0;
            if (fromDate.getTime() > toDate)
                return;
            (_d = this.props.claimsStore) === null || _d === void 0 ? void 0 : _d.updateFromDate(fromDate);
        }
    });
    Object.defineProperty(ClaimList.prototype, "onToDateChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b, _c, _d;
            var toDate = e;
            var fromDate = (_c = (_b = (_a = this.props.claimsStore) === null || _a === void 0 ? void 0 : _a.fromDate) === null || _b === void 0 ? void 0 : _b.getTime()) !== null && _c !== void 0 ? _c : 0;
            if (toDate.getTime() < fromDate)
                return;
            (_d = this.props.claimsStore) === null || _d === void 0 ? void 0 : _d.updateToDate(toDate);
        }
    });
    Object.defineProperty(ClaimList.prototype, "buildDurationString", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (durationSeconds) {
            if (!durationSeconds || durationSeconds <= 0)
                return '';
            var minutes = Math.floor(durationSeconds / 60);
            var seconds = durationSeconds - (minutes * 60);
            var secondsString = seconds.toString();
            if (secondsString.length < 2)
                secondsString = '0' + secondsString;
            return minutes.toString() + ':' + secondsString;
        }
    });
    Object.defineProperty(ClaimList.prototype, "getAverageRating", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (calls) {
            var ratingSum = 0;
            var ratingCount = 0;
            for (var _i = 0, calls_1 = calls; _i < calls_1.length; _i++) {
                var call = calls_1[_i];
                if (call.rating > 0) {
                    ratingSum += call.rating;
                    ratingCount++;
                }
            }
            if (ratingCount === 0)
                return 0;
            return ratingSum / ratingCount;
        }
    });
    Object.defineProperty(ClaimList.prototype, "buildCellStyle", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (width) {
            return {
                width: width,
                maxWidth: width,
                minWidth: width,
                overflow: 'hidden'
            };
        }
    });
    Object.defineProperty(ClaimList.prototype, "onClaimsListScroll", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            if (this.header) {
                var target = e.target;
                this.header.scrollLeft = target.scrollLeft;
            }
        }
    });
    ClaimList = __decorate([
        inject('claimsStore'),
        inject('addressBookStore'),
        inject('languageStore'),
        observer
    ], ClaimList);
    return ClaimList;
}(React.Component));
export default ClaimList;
